export default __webpack_public_path__ + "static/media/Contemporary.cf81b040.jpg";